// import DashboardLayout from "@/pages/Dashboard/Layout/DashboardLayout.vue";
import AuthLayout from "@/pages/Dashboard/Pages/AuthLayout.vue";
import ContentLayout from "@/pages/Layout/ContentLayout.vue";
// Components pages
//import middleware
import auth from "@/middleware/auth";
import guest from "@/middleware/guest";
import { isAgencySocialSite } from "@/config/agencyRuntime";
//Auth
import Login from "@/pages/Dashboard/Pages/Login.vue";
import ChatDomainLaunchNotice from "@/pages/Dashboard/Pages/ChatDomainLaunchNotice.vue";
import HubSunset from "@/pages/Dashboard/Pages/HubSunset.vue";
import LegacySocialRedirect from "@/pages/Dashboard/Pages/LegacySocialRedirect.vue";
// Workplace Pages
import NewFeeds from "@/pages/Workplace/Pages/NewFeeds.vue";
import Group from "../pages/Workplace/Pages/Group/Group.vue";
import PostDetail from "../pages/Workplace/Pages/PostDetail.vue";
import ListGroup from "../pages/Workplace/Pages/ListGroup/GroupOverview.vue";
import Profile from "../pages/Workplace/Pages/Profile.vue";
//Category
import Category from "@/pages/Workplace/Pages/Category/Category.vue";
import HomeCategory from "@/pages/Workplace/Pages/Category/HomeCategory.vue";
//Other
import News from "@/pages/Workplace/Pages/News.vue";
import GroupSetting from "../pages/Workplace/Pages/Group/GroupSetting.vue";
import ErrorPage from "../pages/Workplace/Pages/ErrorPage.vue";
import CompanyStructure from "../pages/Components/SidebarPlugin/CompanyStructureSideBar.vue";
import MemberList from "../pages/Workplace/Pages/MemberList.vue";
import Messenger from "../pages/Workplace/Pages/Messager/Messager.vue";
import OpenPrivateDm from "../pages/Workplace/Pages/Messager/OpenPrivateDm.vue";
import UpdateUserPage from "../pages/Workplace/Pages/UpdateUserPage.vue";
import NoLoginLayout from "../pages/Layout/NoLoginLayout.vue";
import ForgotPassword from "../pages/Workplace/Pages/NoLogin/ForgotPassword.vue";
import ChangePassword from "../pages/Workplace/Pages/NoLogin/ChangePassword.vue";
import ViewFile from "../pages/Workplace/Pages/NoLogin/ViewFile.vue";
import GroupList from "../pages/Workplace/Pages/AdminManagement/GroupList.vue";
import ChatBot from "../pages/Workplace/Pages/AdminManagement/ChatBot.vue";
import Stickers from "../pages/Workplace/Pages/AdminManagement/Stickers.vue";
import Media from "../pages/Workplace/Pages/AdminManagement/Media.vue";
import Forms from "../pages/Workplace/Pages/AdminManagement/Forms.vue";
import FormEditor from "../pages/Workplace/Pages/AdminManagement/FormEditor.vue";
import FormResponses from "../pages/Workplace/Pages/AdminManagement/FormResponses.vue";
import BugReports from "../pages/Workplace/Pages/AdminManagement/BugReports.vue";
let authPages = {
    path: "/",
    component: AuthLayout,
    name: "Authentication",
    children: [
        {
            path: "/login",
            name: "Login",
            component: Login,
            meta: { middleware: guest }
        },
        {
            path: "/chat",
            redirect: "/new-feeds",
        },
        {
            path: "/agency-login",
            name: "AgencyLogin",
            component: Login,
            meta: { middleware: guest }
        },
        {
            path: "/legacy-social-redirect",
            name: "LegacySocialRedirect",
            component: LegacySocialRedirect,
            meta: { middleware: guest }
        },
        {
            path: "/auth/hub-sunset",
            name: "HubSunset",
            component: HubSunset,
            meta: { middleware: auth, hideGlobalTopbar: true, fullscreen: true },
        },
        {
            path: "/chat-domain-launch",
            name: "ChatDomainLaunch",
            redirect: { name: "HubSunset" },
            meta: { middleware: auth }
        },
        {
            path: "/chat-domain-launch-legacy",
            name: "ChatDomainLaunchLegacy",
            component: ChatDomainLaunchNotice,
            meta: { middleware: auth }
        },
    ]
};
let workplacePages = {
    path: "/",
    component: ContentLayout,
    meta: { middleware: auth },
    children: [
        {
            path: "new-feeds",
            name: "New Feeds",
            components: { default: NewFeeds },
            meta: { middleware: auth, tab: 'workplace' },
            children: [
                {
                    path: ":post_id",
                    name: "New Feeds Post",
                    components: { default: NewFeeds },
                    meta: { middleware: auth, tab: 'workplace' },
                }
            ]
        },
        {
            path: "groups",
            name: "Groups",
            components: { default: ListGroup },
            meta: { middleware: auth, tab: 'workplace', navbarAbsolute: true },
            children: [
                {
                    path: ":group_type",
                    name: "Groups Type",
                    components: { default: ListGroup },
                    meta: { middleware: auth, tab: 'workplace', navbarAbsolute: true },
                },
            ]
        },
        {
            path: "news",
            name: "News",
            components: { default: News },
            meta: { middleware: auth, tab: 'workplace' },
        },
        {
            path: "group/:group_id",
            name: "Group",
            components: { default: Group },
            meta: { middleware: auth, tab: 'workplace' },
            children: [
                {
                    path: ":group_tab",
                    name: "Group Tab",
                    components: { default: Group },
                    meta: { middleware: auth, tab: 'workplace' },
                    children: [
                        {
                            path: ":post_id",
                            name: "Group Post",
                            components: { default: Group },
                            meta: { middleware: auth, tab: 'workplace' },
                        },
                    ]
                },
            ]
        },
        {
            path: "messenger/profile/:user_id",
            name: "messenger_profile",
            component: Profile,
            meta: { middleware: auth, tab: 'workplace' },
        },
        {
            path: "/profile/:user_id",
            name: "profile",
            component: Profile,
            meta: { middleware: auth, tab: 'workplace' },
            children: [
                {
                    path: ":tab",
                    name: "profile_tab",
                    components: { default: Profile },
                    meta: { middleware: auth, tab: 'workplace' },
                },
            ]
        },
        {
            path: "department/:department_id/members/",
            name: "department_members",
            components: { default: MemberList },
            meta: { middleware: auth, tab: 'company-structure' },
        },
        {
            path: "position/:position_id/members/",
            name: "position_members",
            components: { default: MemberList },
            meta: { middleware: auth, tab: 'company-structure' },
        },
        {
            // Deep link hub: https://sotax.online/pm/supporter → chat 1-1 với username
            path: "/pm/:username",
            name: "private_pm",
            component: OpenPrivateDm,
            meta: { middleware: auth, tab: 'messenger' },
        },
        {
            path: "/messenger/dm/:user_id",
            name: "messenger_dm",
            component: OpenPrivateDm,
            meta: { middleware: auth, tab: 'messenger' },
        },
        {
            path: "/messenger/:messenger_id",
            name: "messenger",
            component: Messenger,
            meta: { middleware: auth, tab: 'messenger' },
        },
        {
            path: "/admin-settings/groups",
            name: "Admin setting groups",
            component: GroupList,
            meta: { middleware: auth, tab: 'admin-settings' },
        },
        {
            path: "/admin-settings/chat-bot",
            name: "Admin setting chat bot",
            component: ChatBot,
            meta: { middleware: auth, tab: 'admin-settings' },
            children: [
                {
                    path: ":messenger_id",
                    name: "Admin setting chat bot detail",
                    components: { default: ChatBot },
                    meta: { middleware: auth, tab: 'admin-settings' },
                },
            ]
        },
        {
            path: "/admin-settings/stickers",
            name: "Admin setting stickers",
            component: Stickers,
            meta: { middleware: auth, tab: 'admin-settings' },
            children: [
                {
                    path: ":messenger_id",
                    name: "Admin setting stickers detail",
                    components: { default: Stickers },
                    meta: { middleware: auth, tab: 'admin-settings' },
                },
            ]
        },
        {
            path: "/admin-settings/media",
            name: "Admin setting media",
            component: Media,
            meta: { middleware: auth, tab: 'admin-settings' },
        },
        {
            path: "/admin-settings/forms",
            name: "Admin setting forms",
            component: Forms,
            meta: { middleware: auth, tab: 'admin-settings' },
        },
        {
            path: "/admin-settings/forms/create",
            name: "Admin setting forms create",
            component: FormEditor,
            meta: { middleware: auth, tab: 'admin-settings' },
        },
        {
            path: "/admin-settings/forms/:form_id/edit",
            name: "Admin setting forms edit",
            component: FormEditor,
            meta: { middleware: auth, tab: 'admin-settings' },
        },
        {
            path: "/admin-settings/forms/:form_id/responses",
            name: "Admin setting forms responses",
            component: FormResponses,
            meta: { middleware: auth, tab: 'admin-settings' },
        },
        {
            path: "/admin-settings/bug-reports",
            name: "Admin setting bug reports",
            component: BugReports,
            meta: { middleware: auth, tab: 'admin-settings' },
        }
    ]
};
let notificationPages = {
    path: "/",
    component: ContentLayout,
    meta: { middleware: auth },
    children: [
        {
            path: "/notification/:notification_id/group/:group_id/post/:post_id",
            name: "Notification Group Post",
            components: { default: Group },
            meta: { middleware: auth, tab: 'notification' },
            tab: 'notification'
        },
    ]
};
let categoryPages = {
    path: "/",
    component: ContentLayout,
    meta: { middleware: auth },
    children: [
        {
            path: "/category-home",
            name: "home_category",
            component: HomeCategory,
            meta: { middleware: auth, tab: 'category' },
        },
        {
            path: "/category/:category_id",
            name: "category",
            component: Category,
            meta: { middleware: auth, tab: 'category' },
        },
    ]
};
let postDetail = {
    path: "/post/image/:single_post_id",
    name: "PostDetail",
    component: PostDetail,
    meta: { middleware: auth },
};
let groupSetting = {
    path: "/group-setting/:group_id",
    name: "group_setting",
    component: GroupSetting,
    meta: { middleware: auth, tab: 'group_setting' },
    children: [
        {
            path: "/group-setting/:group_id/:tab",
            name: "group_setting_child",
            component: GroupSetting,
            meta: { middleware: auth, tab: 'group_setting' },
        },
    ]
};
let companyStructure = {
    path: "/company-structure/",
    name: "company_structure",
    component: CompanyStructure,
    meta: { middleware: auth, tab: 'company_structure' },
};
let errorPage = {
    path: "/error",
    name: "Error page",
    component: ErrorPage,
};
let viewFilePage = {
    path: "/view-file",
    name: "View file page",
    component: ViewFile,
};
let firstStepPage = {
    path: "/update-user",
    name: "Update user page",
    component: UpdateUserPage,
};
let noLoginPages = {
    path: "/",
    component: NoLoginLayout,
    children: [
        {
            path: "forgot-password",
            name: "Forgot password",
            components: { default: ForgotPassword },
        },
        {
            path: "change-password",
            name: "Change password",
            components: { default: ChangePassword },
        },
    ]
};
let wikiPages = {
    path: "/",
    component: ContentLayout,
    meta: { middleware: auth },
    children: [
        {
            path: "wiki-home",
            name: "home_wiki",
            component: HomeCategory,
            meta: { middleware: auth, tab: 'wiki' },
        },
        {
            path: "wiki/:category_id",
            name: "wiki_page",
            component: Category,
            meta: { middleware: auth, tab: 'wiki' },
        },
    ]
};
// let adminPages = {
//   path: "/dashboard",
//   component: ContentLayout,
//   meta: {middleware: auth},
//   children: [
//     {
//       path: "dashboard",
//       name: "Dashboard",
//       components: {default: Dashboard},
//       meta: {middleware: auth}
//     }
//   ]
// };
const routes = [
    {
        path: "/",
        redirect: () => {
            if (typeof window !== "undefined" && isAgencySocialSite()) {
                if (!localStorage.getItem("access_token")) {
                    return "/agency-login";
                }
            }
            return "/new-feeds";
        }
    },
    authPages,
    workplacePages,
    notificationPages,
    categoryPages,
    postDetail,
    groupSetting,
    errorPage,
    companyStructure,
    firstStepPage,
    noLoginPages,
    viewFilePage,
    wikiPages
];
export default routes;
